import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  Title,
  Mark,
  PicHolder,
  PicPivot
} from "./VisionariesSlide4.style"

import MarkIcon from "./mark.svg"

export default function VisionariesSlide4() {
  return (
    <Holder>
      <PicPivot>
        <PicHolder>
          <Pic src="/assets/images/about/taylor_la.jpg" />
          <Overlay>
            <Caption>
              <Title>
                LA Architects – Returned Assets
                <br />
                Architect
              </Title>
              <Text>
                LA are unique and expert architects. Specialising in the design
                and delivery of sports, arts, libraries, theatre, and other
                civil projects including urban regeneration.
              </Text>
              <Text>
                For 29 years LA Architects have been designing and creating
                buildings and facilities that inspire excellence in sport, or
                simply joy in people.
              </Text>
              <Text>
                The reason for this is simple ... they enjoy what they do and
                they do it well.
              </Text>
              <Mark src={MarkIcon}></Mark>
            </Caption>
          </Overlay>
        </PicHolder>
      </PicPivot>
    </Holder>
  )
}
